<div class="fantasy-container">
  <fgb-mobile-page-header
    [showAfter]="false"
    [backButtonLink]="'/games-v2'"
    [pageTitle]="'fantasy.page.title'"
  ></fgb-mobile-page-header>

  <ng-container *ifScreenSize="screenType.Desktop">
    <div class="container d-flex flex-column">
      <a class="back-btn text-white font-size-14 d-flex flex-row align-items-center fw-bold" [routerLink]="'/games-v2'"
        ><span class="material-symbols-outlined"> keyboard_arrow_left </span>{{ 'fantasy.back.to.game' | translate }}</a
      >

      <img class="banner-img" src="assets/images/games/pick-a-player-banner.png" alt="pick a player banner" />
    </div>
  </ng-container>
  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="container mobile-banner-container">
      <img class="banner-img" src="assets/images/games/pick-a-player-banner.png" alt="pick a player banner" />
    </div>
  </ng-container>

  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="container points-leaderboard-container d-flex flex-row w-100 pt-2">
      <div class="leaderboard-container justify-content-between d-flex flex-row bg-primary align-items-center">
        <div class="rank-icon">
          <span class="material-symbols-outlined"> crown </span>
        </div>
        <div class="rank-details d-flex flex-column align-items-end">
          <p class="font-size-10 text-uppercase text-white fw-bold mb-0">{{ 'fantasy.season.rank' | translate }}</p>

          <p class="font-size-24 text-white fw-bold mb-0">{{ currentUser?.Position }}</p>
        </div>
      </div>

      <div class="points-container d-flex flex-row justify-content-between bg-primary align-items-center">
        <div class="rank-icon">
          <span class="material-symbols-outlined"> trending_up </span>
        </div>
        <div class="points-details d-flex flex-column align-items-end">
          <p class="font-size-10 text-uppercase text-white fw-bold mb-0">{{ 'fantasy.total.points' | translate }}</p>

          <p class="font-size-24 text-white fw-bold mb-0">{{ currentUser?.Points }}</p>
        </div>
      </div>
    </div>
  </ng-container>

  <fgb-fantasy-nav-v2></fgb-fantasy-nav-v2>
  <router-outlet></router-outlet>
</div>
